import { hexToRgba, isColorLight } from "../../../utils/FunctionsGlobals";


/* eslint-disable import/no-anonymous-default-export */
export interface ISearchTypes {
    label: string;
    options: Array<{ label: string; value: string; type: string }>;
}

export interface ISearchCode {
    label: string;
    value: string;
    type: string;
}

export const SearchCity: Array<ISearchCode> = [
    { label: 'Campina Grande', value: '1', type: 'city' },
    { label: 'João Pessoa', value: '2', type: 'city' },
    { label: 'Patos', value: '3', type: 'city' },
    { label: 'São Paulo', value: '4', type: 'city' },
    { label: 'Minas Gerais', value: '5', type: 'city' },
    { label: 'Novo Hamburgo', value: '6', type: 'city' },
    { label: 'Campo Bom', value: '7', type: 'city' },
];

export const SearchDistrict: Array<ISearchCode> = [
    { label: 'Campos', value: '1', type: 'district' },
    { label: 'Centro', value: '2', type: 'district' },
    { label: 'Jardins', value: '3', type: 'district' },
    { label: 'Flores', value: '4', type: 'district' },
    { label: 'Portal', value: '5', type: 'district' },
];

export const SearchType: Array<ISearchCode> = [
    { label: 'Apartamento', value: '1', type: 'type' },
    { label: 'Casa', value: '2', type: 'type' },
    { label: 'Casa em Condomínio', value: '3', type: 'type' },
    { label: 'Cobertura', value: '4', type: 'type' },
    { label: 'Terreno', value: '5', type: 'type' },
];

export const SearchCode: Array<ISearchCode> = [
    { label: '36', value: '36', type: 'code' },
    { label: '45', value: '45', type: 'code' },
    { label: '65', value: '65', type: 'code' },
    { label: '110', value: '110', type: 'code' },
    { label: '115', value: '115', type: 'code' },
    { label: '135', value: '135', type: 'code' },
];

const customSelectStyles = (color: string, colorArrow?: string) => {
    return {
        control: (base: any) => ({
            ...base,
            background: 'transparent',
            boxShadow: 'none',
            border: 0,
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            color: colorArrow || 'white',
        }),
        placeholder: (base: any) => ({
            ...base,
            color: 'white',
        }),
        singleValue: (base: any) => ({
            ...base,
            color: 'white',
        }),
        input: (base: any) => ({
            ...base,
            color: 'white',
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            backgroundColor: colorArrow || 'transparent',
        }),
    };
};

export const customSelectPropertiesStyles = (
    color: string,
    cor_fundo: string,
    select: string
) => {


    return {
        control: (base: any) => ({
            ...base,
            background: cor_fundo,
            boxShadow: 'none',
            borderTop: `1px solid ${color}`,
            borderBottom: `1px solid ${color}`,
            borderLeft: 'none',
            borderRight: 'none',
            borderRadius: 0,
            minWidth: '100%',
            minHeight: 40,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 500,
            ':hover': {
                borderColor: `${hexToRgba(color, 0.6)} !important`
            }
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            color: color || '#374151',
            padding: '0 12px',
        }),
        placeholder: (base: any) => ({
            ...base,
            color: color,
            fontWeight: 500,
            fontSize: 14,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
        }),
        singleValue: (base: any) => ({
            ...base,
            color: color,
            fontWeight: 500,
            fontSize: 14,
            textTransform: 'uppercase',         // opcional (se quiser manter tudo caps ao selecionar)
            letterSpacing: '0.04em',
        }),
        container: (base: any) => ({
            ...base,
            minWidth: '100%',
            color: color || '#374151',
        }),
        indicatorSeparator: (base: any) => ({
            ...base,
            backgroundColor: 'transparent',
        }),
        menu: (base: any) => ({
            ...base,
            backgroundColor: cor_fundo,
            color: color,
            zIndex: 9999,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            border: `1px solid ${color}`,
            borderRadius: 6,
        }),
         option: (base: any, state: any) => ({
           ...base,
           backgroundColor: state.isSelected
             ? select                    // selecionado
             : state.isFocused
             ? hexToRgba(select, 0.7)                // hover
             : cor_fundo,                   // normal
           color: state.isSelected && !isColorLight(select)
             ? "#FFFFFF"                    // selecionado
             : state.isFocused && !isColorLight(select)
             ? "#FFFFFF"                      // hover
             : color, 
           cursor: 'pointer',
           ':active': { backgroundColor: cor_fundo },
         }),
        valueContainer: (base: any) => ({
            ...base,
            padding: '0 16px',
        }),
        input: (base: any) => ({
            ...base,
            color: color,   // em vez de '#374151'
            fontSize: 14,
        }),
    };
};

export default {
    customSelectStyles,
    customSelectPropertiesStyles,
};
